import { render, staticRenderFns } from "./HelpCenterCards.vue?vue&type=template&id=21452f75"
import script from "./HelpCenterCards.vue?vue&type=script&lang=js"
export * from "./HelpCenterCards.vue?vue&type=script&lang=js"
import style0 from "./HelpCenterCards.vue?vue&type=style&index=0&id=21452f75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports